import React from 'react';
import PropTypes from 'prop-types';
import * as actions from '../../actions/merchantDataActions';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { ProgressSnapshot } from '@forwardfinancing/component-library';
import { trackPageView } from '@forwardfinancing/analytics-frontend-library/index';

export class HomePage extends React.Component {
  constructor(props) {
    super(props);
    // need to update this to ensure it only fetches if data is not present
    this.props.actions.fetchMerchantData();
  }

  componentDidMount() {
    trackPageView({page: 'Home'});
    this.setPercentagePaidLabel();
  }
  componentDidUpdate() {
    this.setPercentagePaidLabel();
  }
  // SC-200 needed to change label to 'Paid' for compliance
  setPercentagePaidLabel() {
    const textElement = document.querySelector("text.progress-slider__percentage-text")
    if (textElement) {
      textElement.textContent = `${Math.round(this.props.merchantData.current_advance.percentage_repaid)}% Paid`
    }
  }

  render() {
    // translate Rails payload
    const {
      percentage_repaid,
      balance,
      payments_remaining,
      expected_repayment_date
    } = this.props.merchantData.current_advance;

    return (
      <div className="home-page page full-width-at-mobile">
        <div className="home-page__content centered-at-tab centered-at-phone">
          <ProgressSnapshot
            progressPercentage={Math.round(percentage_repaid)}
            displayValue={balance}
            displayLabel={"Balance: "}
            paymentsRemaining={payments_remaining}
            expectedRepaymentDate={expected_repayment_date}
            infoMessage={"Balance excludes pending payments"}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state){
  return {
    merchantData: state.merchantData
  };
}

function mapDispatchToProps(dispatch){
  return{
    actions: bindActionCreators(actions, dispatch)
  };
}

HomePage.propTypes = {
  merchantData: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
